import { AlertTriangle, Clock, ShoppingBag, Wallet } from "lucide-react";

import { alertaEsquecido, gaveta, hora, reais, sangrias, suprimentos, tempoAberto, totalVendido } from "../lib/caixa";

function Numero({ icone: Icone, rotulo, valor, dica, destaque, e2e }) {
  return (
    <div className={`rounded-2xl border p-4 sm:p-5 ${destaque ? "bg-emerald-500/10 border-emerald-500/40" : "bg-card"}`} data-e2e={e2e}>
      <p className="text-sm font-medium text-muted-foreground flex items-center gap-2"><Icone className="w-4 h-4" />{rotulo}</p>
      <p className={`mt-1 text-3xl font-black tabular-nums tracking-tight ${destaque ? "text-emerald-700 dark:text-emerald-400" : ""}`}>{valor}</p>
      {dica ? <p className="text-xs text-muted-foreground mt-1">{dica}</p> : null}
    </div>
  );
}

/** Os três números do caixa aberto + aviso de caixa esquecido. */
export default function PainelAberto({ caixa, resumo }) {
  const aviso = alertaEsquecido(caixa);
  const est = resumo?.estatisticas || {};
  const partesGaveta = [`abertura ${reais(caixa.valor_abertura)}`];
  if (sangrias(resumo)) partesGaveta.push(`sangrias −${reais(sangrias(resumo))}`);
  if (suprimentos(resumo)) partesGaveta.push(`suprimentos +${reais(suprimentos(resumo))}`);
  return (
    <div className="space-y-3">
      {aviso && (
        <p className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 text-sm flex gap-2" data-e2e="caixa-esquecido">
          <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />{aviso}
        </p>
      )}
      <div className="grid gap-3 sm:grid-cols-3">
        <Numero icone={Wallet} rotulo="Dinheiro na gaveta" valor={reais(gaveta(caixa, resumo))} destaque e2e="dinheiro-gaveta"
          dica={`O que deve ter em espécie: ${partesGaveta.join(" · ")}`} />
        <Numero icone={ShoppingBag} rotulo="Vendido neste caixa" valor={reais(totalVendido(resumo))}
          dica={est.total_pedidos ? `${est.total_pedidos} venda(s) · ticket ${reais(est.ticket_medio)}` : "Nenhuma venda ainda"} />
        <Numero icone={Clock} rotulo="Aberto há" valor={tempoAberto(caixa.opened_at)}
          dica={`Por ${caixa.usuario_nome || "—"}, às ${hora(caixa.opened_at)}`} />
      </div>
    </div>
  );
}
